import { Component, OnInit } from '@angular/core';
import anime from 'animejs';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    const textWrapper = document.getElementById('title');

    if (textWrapper != null) {
      var text = '';
      text += 'Hi,'.replace(/\S/g, "<span class='letter'>$&</span>") + '<br/>' + 
      'I\'m nuyonu,'.replace(/\S/g, "<span class='letter'>$&</span>") + '<br/>' + 
      'full stack developer'.replace(/\S/g, "<span class='letter'>$&</span>") + '<br/>' +
      '[work in progress]'.replace(/\S/g, "<span class='letter'>$&</span>");
      textWrapper.innerHTML = text;
    }

    anime.timeline({loop: false})
      .add({
        targets: '.letter',
        scale: [4, 1],
        opacity: [0, 1],
        translateZ: 0,
        easing: "easeOutExpo",
        duration: 1000,
        delay: (_, i: number) => 100 * i
      });

      var pathEls = document.querySelectorAll('path');
      for (var i = 0; i < pathEls.length; i++) {
        var pathEl = pathEls[i];
        var offset = anime.setDashoffset(pathEl);
        pathEl.setAttribute('stroke-dashoffset', offset.toString());
        anime({
          targets: pathEl,
          strokeDashoffset: [offset, 0],
          duration: anime.random(1000, 3000),
          delay: anime.random(0, 2000),
          loop: true,
          direction: 'alternate',
          easing: 'easeInOutSine',
          autoplay: true
        });
      }
  }

}
